import Root from "../layouts/Root";
import DesignTable from "../components/designs/DesignTable";
import IconText from "../components/IconText";
import {faMobile} from "@fortawesome/free-solid-svg-icons/faMobile";
import {faApple} from "@fortawesome/free-brands-svg-icons";
import IosAppsTable from "../components/apps/IosAppsTable";
import MacAppsTable from "../components/apps/MacAppsTable";
import iconApps from "../assets/img/icon-apps.png";
export default function Designs() {
    
    const iconStyle = {
        width: "32px",
        height: "32px",
        marginRight: "10px",
        verticalAlign: "middle",
    };
    
    const rightContent = (
        <div>
            <h1><IconText icon={faMobile} text={"Mobile"}/> </h1>
            <IosAppsTable/>
            <h1><IconText icon={faApple} text={"macOS"}/> </h1>
            <MacAppsTable/>
        </div>
    )
    return (
        <div className="design-page">
            <Root rightContent={rightContent} icon={iconApps}/>
        </div>
    )
}
